import React from 'react';
import CommunityImg from '../Common/CommunityImg/CommunityImg';
import './EventBlog.scss';

const EventBlog = ({
  blog
}) => {

  const {
    node : {
      feature_image,
      title,
      excerpt,
      tags,
      primary_author : {
        name,
        profile_image
      },
      published_at,
      slug
    }
  } = blog;

  const eventTags = tags?.splice(0,2);

  const openBlog = () => window.open(`https://www.noissue.co/blog/${slug}`, '_blank', 'noopener');

  return (
    <>
      <div className="event-blog-item-container" role="presentation" onClick={()=>openBlog()}>  
        <div className="event-blog-item-image">
          <CommunityImg src={feature_image} alt="blog img" />
        </div>
        <div className="event-blog-item-details">
          <div className="event-blog-item-details-title">
            <div className="event-blog-item-details-company">
              {title}
            </div>
            <div className="event-blog-item-details-location">
              {excerpt}
            </div>
          </div>
          <div className="event-blog-item-details-readmore">Read More</div>
          <div className="event-blog-item-publisher">
           <div
            className="event-blog-item-logo-image"
            style={{ backgroundImage: `url(${profile_image})` }}
          />
          <div className="event-blog-item-publisher-details">
            <span className="event-blog-item-publisher-name">by {name}</span>
            <span className="event-blog-item-publisher-published">{published_at}</span>
          </div>
          </div>
          <div className="event-blog-item-details-tags">
            {
              eventTags.map((tagItem, idx) => {
                return <span key={`tag-${idx}`}>{tagItem.name}</span>
              })
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default EventBlog;
